import { supabase } from '../supabaseClient'; // Ensure this is correctly imported

export const getProfilePictureName = (bucket: string, id: string) => `${bucket}/${id}.png`;

// Helper function to delete an old profile picture from storage
export const deleteProfilePicture = async (bucket: string, id: string | null) => {
  if (!id) {
    return;
  }

  try {
    const profilePicturePath = `${bucket}/${id}.png`;
    const { error } = await supabase
      .storage
      .from('profile-pictures')
      .remove([profilePicturePath]);

    if (error) {
      console.error(`Error deleting profile picture ${id} in bucket ${bucket}:`, error);
    }
  } catch (error) {
    console.error(`Unexpected error deleting profile picture ${id} in bucket ${bucket}:`, error);
  }
};

// Helper function to fetch a profile picture for a single teacher
export const fetchProfilePicture = async (bucket: string, id: string | null) => {
  if (!id) {
    return null;
  }

  try {
    const profilePicturePath = `${bucket}/${id}.png`;
    const { data: profilePicFile, error: picError } = await supabase
      .storage
      .from('profile-pictures')
      .download(profilePicturePath);

    if (picError) {
      console.error(`Error fetching profile picture ${id} in bucket ${bucket}:`, picError);
      return null; // Return null or a default image URL in case of an error
    }

    // Create an object URL from the downloaded file and return it
    return URL.createObjectURL(profilePicFile);
  } catch (error) {
    console.error(`Unexpected error fetching profile picture ${id} in bucket ${bucket}:`, error);
    return null; // Return null or a default image URL in case of an unexpected error
  }
};
